module.exports = __webpack_public_path__ + "moonhouse.ab478ec97fef4c2ed6bb.eot";


//////////////////
// WEBPACK FOOTER
// C:/angular/glow/src/assets/fonts/moonhouse.eot
// module id = ../../../../../src/assets/fonts/moonhouse.eot
// module chunks = styles